
const template = `
<div>

    <div v-for="(vn, i) in funnel.idsMap.system_responses" :key="'vn-'+i" :id="vn" v-if="isNotification(vn)" class="grid">
        <div class="s12 m6 l8 clm center">
            <div :class="funnel.elements[vn].props.class">
                <div class="icon">
                    <img :alt="funnel.elements[vn].props.alt || 'Notification icon'" class="iconic iconic-sm" data-direction="left" :src="computedAlertIcon(funnel.elements[vn])">
                </div>
                <span aria-live="assertive" role="alert" v-html="funnel.elements[vn].text"></span>
            </div>
        </div>
    </div>

</div>

`;

export default {
    name: 'b-notify',
    template,
    computed: {
        ...Vuex.mapGetters([
            'funnel'
        ])   
    },
    methods: {
        computedAlertIcon: function(input){
            console.log(input);
            var iconName = ''
            if (input.uid.indexOf('warning') >= 0) {
                iconName = 'thumb-down'
            }
            else{
                return
            }
            return '/static/images/iconic/' + iconName + '.svg'
        },
        isNotification: function (vnUid) {
            return (this.funnel.elements[vnUid].type == 'notification' && this.funnel.elements[vnUid].text);
        }
    }
};